var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 5.2C10.75 4.81208 11.0844 4.5 11.5 4.5C11.9156 4.5 12.25 4.81208 12.25 5.2C12.25 5.58792 11.9156 5.9 11.5 5.9C11.0844 5.9 10.75 5.58792 10.75 5.2ZM10.5 11.2667C10.2031 11.2667 9.9125 11.2463 9.62813 11.2025L8.75313 11.9696C8.64062 12.1271 8.45 12.2 8.25 12.2H7V13.3667C7 13.7546 6.66563 14.0667 6.25 14.0667H5V15.2333C5 15.6213 4.66563 15.9333 4.25 15.9333H0.75C0.335938 15.9333 0 15.6213 0 15.2333V12.4333C0 12.2467 0.0790312 12.0688 0.219656 11.9375L5.15312 7.335C5.05312 6.92375 5 6.5475 5 6.13333C5 3.29833 7.4625 1 10.5 1C13.5375 1 16 3.29833 16 6.13333C16 8.96833 13.5375 11.2667 10.5 11.2667ZM10.5 10.3333C12.9844 10.3333 15 8.45208 15 6.13333C15 3.81371 12.9844 1.93333 10.5 1.93333C8.01562 1.93333 6 3.81371 6 6.13333C6 6.47458 6.04375 6.77792 6.09688 7.11625L6.25313 7.62667L1 12.5296V15H4V13.1333H6V11.2667H8.14688L9.28125 10.205L9.7875 10.2808C10.0188 10.3158 10.2563 10.3333 10.5 10.3333Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.c3f6c82c90b2262b9c5500fda0e12135.svg";
export { ForwardRef as ReactComponent };